// @flow
import { WEB_TYPES_KEYS } from '../Redux/SettingsRedux'
import { initDynamicProperties } from '../Redux/QuoteRedux'
// types
import type {
  DynamicPropertiesType,
  RawTariffContentType,
  TariffsHelps,
  TariffsNames,
  TariffsProperties,
  TariffsSuriIndex, WebsiteOverwriteObject
} from '../Types/TariffsContentType'
import type { TariffDocumentsType } from '../Types/DocumentTypes'

const requiredAttributesInRawTariffContent = ['help', 'insuranceCompany', 'name', 'properties', 'suriIndex']
const optionalAttributesInRawTariffContent = ['icon', 'documents', 'sort', 'dynamicProperties', 'insuranceKey', 'websiteOverwrite']

export default class TariffContentInstance {
  className: string
  isValid: boolean = false
  help: TariffsHelps
  insuranceCompany: string
  documents: ?TariffDocumentsType
  name: TariffsNames = {}
  properties: TariffsProperties
  suriIndex: TariffsSuriIndex
  icon: ?Object
  sort: ?{
    price?: number,
    totalLimitsValueTpl?: number,
    totalLimitsValueCic?: number,
  }
  dynamicProperties: ?DynamicPropertiesType
  websiteOverwrite: ?WebsiteOverwriteObject
  website: ?number
  invalidBecause: { key: string, data: Object }[] = []

  constructor(data: ?Object) {
    this.className = this.constructor.name
    if (data && typeof data === 'object') {
      Object.keys(data).forEach((key) => {
        this[key] = data[key]
      })
    }
  }

  initFromRawTariffContent = (rawTariffContent: RawTariffContentType, formData: Object, website: number) => {
    this.isValid = true
    this.website = website
    if (rawTariffContent.websiteOverwrite && Object.keys(rawTariffContent.websiteOverwrite).length > 0 &&
      rawTariffContent.websiteOverwrite[WEB_TYPES_KEYS[website]]
    ) {
      rawTariffContent = {
        ...rawTariffContent,
        ...rawTariffContent.websiteOverwrite[WEB_TYPES_KEYS[website]]
      }
    }
    requiredAttributesInRawTariffContent.forEach((attributeName) => {
      if (typeof rawTariffContent[attributeName] !== 'undefined') {
        this[attributeName] = rawTariffContent[attributeName]
      } else {
        this.isValid = false
        this.invalidBecause.push({
          key: 'INVALID_QUOTE_CONTENT',
          data: {
            key: attributeName,
          },
        })
      }
    })
    optionalAttributesInRawTariffContent.forEach((attributeName) => {
      if (typeof rawTariffContent[attributeName] !== 'undefined') {
        this[attributeName] = rawTariffContent[attributeName]
      }
    })
    Object.keys(rawTariffContent).forEach((attributeName) => {
      if (attributeName === 'name') {
        if (typeof rawTariffContent[attributeName] === 'string' || Object.keys(rawTariffContent[attributeName]).length === 0) {
          this.name = Object.values(WEB_TYPES_KEYS).reduce((webTypeAcc, webTypeName: string) => {
            webTypeAcc[webTypeName] = rawTariffContent[attributeName]
            return webTypeAcc
          }, { default: rawTariffContent[attributeName] })
        } else if (!rawTariffContent[attributeName].default) {
          const tariffName = Object.values(rawTariffContent[attributeName])[0]
          this.name = {
            default: tariffName,
            "suri.cz": tariffName,
            ...rawTariffContent[attributeName]
          }
        }
      }
    })
    this.initDynamicProperties(formData)
    return this
  }

  getSortValue = (attributeName: string, defaultValue: any = false) => {
    if (this.sort && typeof this.sort[attributeName] !== 'undefined') {
      return this.sort[attributeName]
    }
    return defaultValue
  }

  getPropertiesValue = (propertyName: string, defaultValue: any = false) => {
    if (this.properties && typeof this.properties[propertyName] !== 'undefined') {
      return this.properties[propertyName]
    }
    return defaultValue
  }

  getLimitPropertyValue = (limitPropertyName: string, defaultValue: any = 0) => {
    const limits = this.getPropertiesValue('limits')
    if (limits && typeof limits[limitPropertyName] !== 'undefined') {
      return limits[limitPropertyName]
    }
    return defaultValue
  }

  getSuriIndexValue = () => {
    return this.suriIndex.value
  }

  initDynamicProperties = (formData: Object) => {
    if (this.dynamicProperties) {
      this.properties = {
        ...this.properties,
        ...initDynamicProperties(this.dynamicProperties, formData)
      }
    }
    return this
  }
}
